import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static targets = ["teamCode"]
  static values = {
    lookupUrl: String,
    codeLength: { type: Number, default: 6 }
  }

  async confirm(event) {
    if (this.confirmedSubmission) {
      this.confirmedSubmission = false
      return
    }

    const teamCode = this.normalizedTeamCode()
    this.teamCodeTarget.value = teamCode

    if (teamCode.length !== this.codeLengthValue) return

    event.preventDefault()

    try {
      const response = await fetch(`${this.lookupUrlValue}?team_code=${encodeURIComponent(teamCode)}`, {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        this.submitWithoutPrompt()
        return
      }

      const data = await response.json()
      const result = await Swal.fire({
        title: "Join team?",
        text: `Do you want to join ${data.team_name}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Join team",
        cancelButtonText: "Cancel",
        reverseButtons: true
      })

      if (result.isConfirmed) this.submitWithoutPrompt()
    } catch (_error) {
      this.submitWithoutPrompt()
    }
  }

  normalizedTeamCode() {
    return this.teamCodeTarget.value.trim().toUpperCase()
  }

  submitWithoutPrompt() {
    this.confirmedSubmission = true
    this.element.requestSubmit()
  }
}
